import React, { PureComponent, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import LineChart from './components/lineChart';
import TimeLines from './components/timeLines';
import Scatter from './components/scatter';

export * from './components/LabelsXAxisTime';
export const TYPE_CHART_LINECHART = 'TYPE_CHART_LINECHART';
export const TYPE_CHART_TIMELINE = 'TYPE_CHART_TIMELINE';
export const TYPE_CHART_SCATTER = 'TYPE_CHART_SCATTER';

export const mappingCharts = {
  TYPE_CHART_LINECHART: LineChart,
  TYPE_CHART_TIMELINE: TimeLines,
  TYPE_CHART_SCATTER: Scatter,
};

/* SIZES CHART:
**************************************************************************
*                    WIDTH                                               *
+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*
* widthLegendeVaxis  *                                                   *
*                    *                                                   *
**************************************************************************
*/
const initialControls = [];
/**
 * Chart component
 * Display charts type TYPE_CHART_LINECHART or TYPE_CHART_TIMELINE
 * parameters (props)
 * @param string type = [TYPE_CHART_LINECHART or TYPE_CHART_TIMELINE]
 * @param array/object data = TYPE_CHART_LINECHART (array = [{name, unit, data: [timestamp, val]}])
 * TYPE_CHART_TIMELINE (object = { [eventId]: {name, id, data: [start, end]} })
 * @param string mode
 * @param string language
 * @param number width: chart's width including the size of the widthLegendeVaxis
 * @param number height: chart's height
 * @param number widthLegendeVaxis: legenda's height
 * @param number minDatetim: timestamp format: min value view port haxis
 * @param number maxDatetim: timestamp format: max value view port haxis
 * @param callBackZoom func: function used by zoom events
 * @param zoom bool: allow to zoom (the zoom works only in the lineCharts)
 */
const ChartComponent = (props) => {
  const {
    data,
    mode,
    type,
    width,
    height,
    widthLegendeVaxis,
    minDatetime,
    maxDatetime,
    language,
    callBackZoom,
    zoom,
    controls = initialControls,
    ...otherProps
  } = props;
  const [fwControls, setControls] = useState(controls);
  useEffect(() => {
    setControls([]);
    // https://github.com/rakannimer/react-google-charts/issues/209
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controls, width, height, data]);

  const Chart = !mappingCharts[type] ? LineChart : mappingCharts[type];
  return (
    <Chart
      mode={mode}
      data={data}
      width={width}
      height={height}
      widthLegendeVaxis={widthLegendeVaxis}
      minDatetime={minDatetime}
      maxDatetime={maxDatetime}
      language={language}
      callBackZoom={callBackZoom}
      zoom={zoom}
      controls={fwControls}
      {...otherProps}
    />
  );
};
export default React.memo(ChartComponent);

ChartComponent.propTypes = {
  type: PropTypes.string,
  mode: PropTypes.string,
  data: PropTypes.any.isRequired,
  language: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  widthLegendeVaxis: PropTypes.number,
  minDatetime: PropTypes.number /* timestamp format */,
  maxDatetime: PropTypes.number /* timestamp format */,
  callBackZoom: PropTypes.func,
  zoom: PropTypes.bool,
  labels: PropTypes.shape({
    type: PropTypes.string.isRequired,
    maxVAxis: PropTypes.number,
    widthVAxis: PropTypes.number,
  }),
  chartArea: PropTypes.any,
};

ChartComponent.defaultProps = {
  mode: null,
  language: null,
  width: null,
  height: null,
  widthLegendeVaxis: null,
  minDatetime: null,
  maxDatetime: null,
  callBackZoom: null,
  zoom: false,
};
